var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.926 2.783h1.547V.118A20.189 20.189 0 006.219 0C3.99 0 2.461 1.388 2.461 3.938v2.348H0v2.979h2.461v7.497H5.48V9.266H7.84l.375-2.98H5.478V4.234c0-.861.235-1.45 1.448-1.45z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 9 17' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M6.92579 2.78313H8.47262V0.11803C8.20575 0.0817129 7.28796 0 6.21909 0C3.98886 0 2.46109 1.38772 2.46109 3.93828V6.28561H0V9.26499H2.46109V16.7616H5.4785V9.26569H7.84005L8.21493 6.28631H5.4778V4.23371C5.4785 3.37258 5.71289 2.78313 6.92579 2.78313Z'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };